import { Controller } from "@hotwired/stimulus"
import { get, set, subscribe } from "../lib/session_store"

// The lap-view "Compare" affordance. The reference browser itself lives in the
// ⌘K palette (single comparison surface) — this controller just opens it and
// keeps the on-screen active-badge / Clear in sync with `comparisonLapId`.
export default class extends Controller {
  connect() {
    this._unsub = subscribe("comparisonLapId", (id) => this._syncUI(id))
    this._syncUI(get("comparisonLapId"))
  }

  disconnect() {
    this._unsub?.()
  }

  // Open the ⌘K palette on its reference-browser page.
  toggle() {
    window.dispatchEvent(new CustomEvent("cmdk:open-refs"))
  }

  clear() {
    set("comparisonLapId", null)
    set("comparisonLapLabel", null)
  }

  _syncUI(comparisonId) {
    const trigger = this.element.querySelector("[data-compare-trigger]")
    const badge = this.element.querySelector("[data-compare-badge]")
    const clearBtn = this.element.querySelector("[data-compare-clear]")

    if (comparisonId) {
      if (badge) {
        badge.classList.remove("hidden")
        badge.textContent = "1"
      }
      if (clearBtn) clearBtn.classList.remove("hidden")
      if (trigger) trigger.classList.add("text-vivid-purple")
    } else {
      if (badge) badge.classList.add("hidden")
      if (clearBtn) clearBtn.classList.add("hidden")
      if (trigger) trigger.classList.remove("text-vivid-purple")
    }
  }
}
